import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const DiagramArrowUpShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 24",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M4.5 22.5c0 .8.7 1.5 1.5 1.5h3c.8 0 1.5-.7 1.5-1.5V9c0-.1.1-.2.2-.2H14c.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7L8.6.4C8-.1 7-.1 6.4.4L.3 7.1c-.4.4-.4 1 .1 1.4.1.2.3.3.6.3h3.2c.1 0 .2.1.2.2v13.5z"
    })
  });
};

export { DiagramArrowUpShape };
//# sourceMappingURL=DiagramArrowUpShape.js.map
